const SAVED_DRAFT_ACTION_TYPES = {
  SAVED_DRAFT: 'SAVED_DRAFT',
  UPDATE_SAVE_DRAFT_STATUS: 'UPDATE_SAVE_DRAFT_STATUS',
  SUBMIT_DRAFT: 'SUBMIT_DRAFT',
  FETCH_DRAFTS: 'FETCH_DRAFTS',
  FETCH_DRAFT_LIST: 'FETCH_DRAFT_LIST',
  SEARCH_DRAFT_LIST: 'SEARCH_DRAFT_LIST',
  LOCK_UNLOCK_OR_DELETE_DRAFT: 'LOCK_UNLOCK_OR_DELETE_DRAFT',
  DRAFT_DELETE_COUNTER: 'DRAFT_DELETE_COUNTER',
  UPDATE_DRAFT_ID: 'UPDATE_DRAFT_ID',
  DELETE_DRAFT: 'DELETE_DRAFT',
  SET_DRAFT_ERROR: 'SET_DRAFT_ERROR',
  DRAFT_LOADING: 'DRAFT_LOADING',
  DRAFT_RESPONSE_STATUS: 'DRAFT_REPSONSE_STATUS',
};

export default SAVED_DRAFT_ACTION_TYPES;
